import React, { useEffect, useState } from 'react';
import { Button } from 'baseui/button';
import { Select } from 'baseui/select';
import { HeadingLarge, HeadingMedium } from 'baseui/typography';
import { useStyletron } from 'styletron-react';
import { getProjectsWithReport } from '@gtintel/platform-api';
import ContentContainer from '../ContentContainer';
import { ReportQAContextProvider, useReportQAContext } from '../context';
import RunQAModal from './components/RunQAModal';
const ReportQA = () => {
  const [css] = useStyletron();
  const [, mutate, query] = useReportQAContext();
  const {
    projects,
    selectedProject
  } = query(state => state);
  const [selectValue, setSelectValue] = useState(null);
  useEffect(() => {
    getProjectsWithReport().then(response => {
      mutate(state => ({
        ...state,
        projects: response.results.map(({
          id,
          name,
          reports
        }) => ({
          id,
          label: name,
          reports
        }))
      }));
    });
  }, [mutate]);
  return <ContentContainer>
      <HeadingLarge>Report QA</HeadingLarge>
      <HeadingMedium>Select a project</HeadingMedium>
      <div className={css({
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      width: '50%'
    })}>
        <Select clearable={false} options={projects.map(item => ({
        id: item.id,
        label: `${item.id}: ${item.label}`
      }))} value={selectValue} onChange={value => {
        setSelectValue(value.value);
        mutate(state => ({
          ...state,
          selectedProject: projects.find(project => project.id === value.value[0].id)
        }));
      }} />
        {selectValue ? <Button onClick={() => {
        mutate(state => ({
          ...state,
          modal: {
            ...state.modal,
            content: selectedProject.reports.length === 1 ? 'config' : 'reports',
            open: true,
            selectedReportId: selectedProject.reports.length === 1 ? selectedProject.reports[0].id : null
          }
        }));
      }}>
            Launch Report QA
          </Button> : <Button disabled title="Select a project">
            Launch Report QA
          </Button>}
      </div>
      <RunQAModal />
    </ContentContainer>;
};
const ReportQAPanel = () => {
  return <ReportQAContextProvider>
      <ReportQA />
    </ReportQAContextProvider>;
};
export default ReportQAPanel;